exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".OtherFlow-7bca1323{position:relative}.OtherFlow-7bca1323 .instructions-74961269{text-align:center;max-width:500px;margin:0 auto}\n", ""]);

// Exports
exports.locals = {
	"OtherFlow": "OtherFlow-7bca1323",
	"instructions": "instructions-74961269"
};